/**
 * Validates a GS1 GLN (Global Location Number):
 * - must be exactly 13 digits
 * - the 13th digit must satisfy the GS1 mod-10 check digit algorithm
 */
export function isValidGln(value: string) {
  if (!/^\d{13}$/.test(value)) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += Number(value[i]) * (i % 2 === 0 ? 1 : 3);
  }

  const expectedCheck = (10 - (sum % 10)) % 10;

  return expectedCheck === Number(value[12]);
}
